var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-6',[_c('div',{staticClass:"hd"},[_vm._v("未来交通")]),_c('div',{staticStyle:{"height":"auto","flex":"1","width":"100%"},attrs:{"id":"access"}})])}
var staticRenderFns = []

export { render, staticRenderFns }